import type React from 'react';
import type { InvitationData, TemplateMetadata, BackendOccasionType } from './types';

export interface RegistryEntry {
  metadata: TemplateMetadata;
  component: React.ComponentType<{ data: InvitationData }>;
}

const _map = new Map<string, RegistryEntry>();

export const registry = {
  register(entry: RegistryEntry): void {
    _map.set(entry.metadata.id, entry);
  },

  get(id: string): RegistryEntry | undefined {
    return _map.get(id);
  },

  has(id: string): boolean {
    return _map.has(id);
  },

  getAll(): RegistryEntry[] {
    return Array.from(_map.values());
  },

  getByOccasion(occasionType: BackendOccasionType): RegistryEntry[] {
    return Array.from(_map.values()).filter(
      (e) => e.metadata.occasionType === occasionType,
    );
  },

  size(): number {
    return _map.size;
  },
};
